import { useState, useEffect } from 'react';

export const useSmartLoading = (loadingStates = [], hasData = false) => {
  const [criticalLoaded, setCriticalLoaded] = useState(false);
  const [allLoaded, setAllLoaded] = useState(false);

  useEffect(() => {
    const hasAnyCriticalData = loadingStates.some(state => 
      state === 'succeeded' || state === 'failed'
    );
    
    if ((hasAnyCriticalData || hasData) && !criticalLoaded) {
      setCriticalLoaded(true);
    }

    const allComplete = loadingStates.every(state => 
      state === 'succeeded' || state === 'failed'
    );
    
    if (allComplete && !allLoaded) {
      setAllLoaded(true);
    }
  }, [loadingStates, hasData, criticalLoaded, allLoaded]);

  return {
    showSkeleton: !criticalLoaded,
    showContent: criticalLoaded,
    fullyLoaded: allLoaded
  };
};